import React from 'react'
import PropTypes from 'prop-types'
import ReactLoading from 'react-loading'
import classnames from 'classnames'

import bsVariables from '../../styles/_bs_variables.scss.js'

// todo: replace react-loading with a pure css option
//  https://github.danielcardoso.net/load-awesome/animations/ball-beat.html

const Loading = ({ centered, color, ifTrue, lg, sm, text, type }) => {
  // if this prop is passed, only show when "ifTrue" is truthy
  if (typeof ifTrue !== 'undefined' && !ifTrue) return null

  // const height = lg ? 75 : sm ? 35 : 50 // eslint-disable-line
  const width = lg ? 125 : sm ? 65 : 90 // eslint-disable-line

  return (
    <div
      className={classnames({
        'flex-column-center': centered,
        'h-100': centered,
        'pb-3': text,
        'w-100': centered,
      })}
    >
      {typeof text === 'string' ? <span className={classnames('text-muted', { 'font-200': lg })}>{text}</span> : text}
      <ReactLoading color={color} delay={0} type={type} height={width} width={width} />
    </div>
  )
}

Loading.propTypes = {
  centered: PropTypes.bool,
  color: PropTypes.string,
  ifTrue: PropTypes.bool,
  lg: PropTypes.bool,
  sm: PropTypes.bool,
  text: PropTypes.oneOfType([PropTypes.string,PropTypes.elementType, PropTypes.node]),
  type: PropTypes.oneOf([
    'blank',
    'balls',
    'bars',
    'bubbles',
    'cubes',
    'cylon',
    'spin',
    'spinningBubbles',
    'spokes',
  ]),
}
Loading.defaultProps = {
  centered: true,
  color: bsVariables['$gray-600'],
  ifTrue: undefined,
  lg: undefined,
  sm: undefined,
  text: null,
  type: 'bubbles',
}

export default Loading
